import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetBusinessDisciplinesMutation } from '../apis';
import type { BdQuerySchema } from '../schemas';

export function BusinessDisciplinesSelect({ disabled, ...props }: FormAsyncComboboxProps<BdQuerySchema>) {
  const getName = useCallback(
    (item?: BdQuerySchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink
          to="/settings/business-disciplines/$id"
          params={{ id: `${item.id}` }}
          state={{ naturalBack: true }}
        >
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetBusinessDisciplinesMutation}
      disabled={disabled}
    />
  );
}
